<template>
  <main>
    <tab-condition-header />
      <div class="tab-content page-search-filter" 
      :class="{'section-loading': filterLoading}"
      v-show="status == 'STATUS_UNIT_CONDITION'">
        <unit-condition 
        :formSelect="formSelect"
        :grpOpt="grpOpt"
        :mainPlanOpt="mainPlanOpt"
        :secondaryPlanOpt="secondaryPlanOpt"
        :status="status"
        :custTagOpt="custTagOpt"
        :allTagOpt="allTagOpt"
        :def="custTagDef"
        :prodType1_Opt="prodType1_Opt"
        :prodType2_Opt="prodType2_Opt"
        @set-selected-item="setSelectedItem"
        @go-release-table="goReleaseTable" />
      </div>

      <div class="tab-content page-search-filter" v-show="status == 'STATUS_PREVIEW_CLIENT'">
        <preview-client 
        :title="condition_title"
        :ch-text="option_ch"
        :condition-data="condition_data"
        :status="status"
        @return-unit-condition="returnUnitCondition"
        @go-release-table="goReleaseTable" />
      </div>

      <div class="tab-content" v-show="status == 'STATUS_RELEASE_TABLE'">
        <release-table
        :ch-text="option_ch"
        :condition-data="condition_data"
        :title="condition_title"
        :status="status" />
      </div>
  </main>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {commonMixin} from '@/mixins/common'
import { getGroupOfAgnt, queryPlanCode, getSearchFilter, getAllCustTag, getAllProdType } from '@/service'


import TabConditionHeader from './components/TabConditionHeader'
import UnitCondition from './components/UnitCondition'
import PreviewClient from './components/PreviewClient'
import ReleaseTable from './components/ReleaseTable'

import { debuglog } from 'util';

export default {
  name: 'ConditionTab2',
  mixins: [commonMixin],
  components: {
    UnitCondition, TabConditionHeader, PreviewClient, ReleaseTable
  },
  computed: {
  },
  data () {
    return {
      order: {
          index: 1,
          asc: true
      },
      status: 'STATUS_UNIT_CONDITION',
      checkModalOpen: false,
      reasonType: 1,
      transferModalOpen: false,
      tableData: [
          {

          }
      ],
      grpOpt: [], // 群組
      mainPlanOpt: [],  //  主約
      secondaryPlanOpt: [], //  附約
      condition_title: '',  // 條件名稱
      option_ch: '',  // 選項中文
      condition_data: {},
      formSelect :{
        idage:[],
        agemonth:[],
        custrl:[],
        custrl1:[],
        custrl2:[],
        custrl3:[],
        custrl4:[],
        vip_lvl:[],
        job:[],
        family_incom:[],
        finance:[],
        invest:[],
        marry:[],
        edu:[],
        house:[],
        car:[],
        web_member:[],
        online:[],
        mobile:[],
        payment:[],
        email:[],
        sex:[],
        trans_plpy:[],
        ecall:[],
        claimoffset:[],
        matag_month:[],
        annuity_month:[],
        pla1_month:[],
        plc1_month:[],
        plf1_month:[],
        birthmonth:[],
        incomy:[],
        home_addr_zip:[],
        groups:[],
        prod_codes:[],
        prod_codes_n:[],
        home_addr3:[],
        year_select:[
          {"name":'半年內',"option":'半年內'},
          {"name":'一年內',"option":'一年內'},
          {"name":'二年內',"option":'二年內'},
          {"name":'三年內',"option":'三年內'},
          {"name":'四年內',"option":'四年內'},
          {"name":'五年內',"option":'五年內'}
        ],
        month_select:[
          {"name":'1',"option":'1'},
          {"name":'2',"option":'2'},
          {"name":'3',"option":'3'},
          {"name":'4',"option":'4'},
          {"name":'5',"option":'5'},
          {"name":'6',"option":'6'},
          {"name":'7',"option":'7'},
          {"name":'8',"option":'8'},
          {"name":'9',"option":'9'},
          {"name":'10',"option":'10'},
          {"name":'11',"option":'11'},
          {"name":'12',"option":'12'}
        ],
        cnt_select:[
          {"name":'2~4 次',"option":'1'},
          {"name":'5~7 次',"option":'2'},
          {"name":'8 次以上',"option":'3'}
        ],
        cwp:[],
        recent_birthday:[], //近期生日
        mkt_level:[],
        mkt_type:[]
      },
      filterLoading: false,
      custTagOpt:[], //客戶標籤
      prodType1_Opt:[], //已投保_商品類別
      prodType2_Opt:[], //未投保_商品類別
      custTagDef: {}, //客戶標籤定義(說明視窗使用)
      allTagOpt: [], //所有的客戶標籤選項
    }
  },
  methods: {
    ...mapActions([
      'setPageLock'
    ]),
    initIndex () {  //  初始化
      this.filterLoading = true
      getSearchFilter(this.$store.state.userInfo.id).then(result => {
        this.filterLoading = false
        if(result.header && result.header.status == '200' && result.body){
          // 過濾沒有 local 設定的 Key
          let filterAry = Object.keys(this.formSelect)

          result.body.conditions_list.forEach(item => {
            // 過濾沒有 local 設定的 Key
            if(filterAry.includes(item.field_name)){  // 只設定有對應到 formSelect 的 key
              this.formSelect[item.field_name].push(item)
            }
          })
        }
        this.formSelect.birthmonth = this.formSelect.birthmonth.sort(function (a, b) {return a.ser_no - b.ser_no});
      })
      this.setGroupOpt() //  取得群組 List
      this.setPlanOpt()  // 取得投資商品 List
      this.setCustTagOpt() // 取得客戶標籤 List
      this.setProdTypeOpt() // 取得商品類別 List
      this.setRecentBirthdayOpt() //近期生日下拉初始化
    },
    setPlanOpt () {  // 取得投資商品 List
      //主約
      queryPlanCode(this.$store.state.userInfo.id, '1').then(result => {
        if(result.body.contract) {
          this.mainPlanOpt = result.body.contract.map(item => {
            return {
              val: item.PROD_ID,
              text: `${item.PROD_NM} (${item.PROD_ID})`
            }
          })
        } else {
          this.mainPlanOpt = []
        }
      })
      //副約
      queryPlanCode(this.$store.state.userInfo.id, '2').then(result => {
        if(result.body.contract) {
          this.secondaryPlanOpt = result.body.contract.map(item => {
            return {
              val: item.PROD_ID,
              text: `${item.PROD_NM} (${item.PROD_ID})`
            }
          })
        } else {
          this.secondaryPlanOpt = []
        }
      })
    },
    setGroupOpt () {  //  取得群組 List
      // getGroupOfAgnt(this.$store.state.userInfo.id, this.$store.state.userInfo.id).then(result => {
      //   if(result.header && result.header.status == '200') {
      //     this.grpOpt = result.body.groups.map(eachGroup => {
      //       return {
      //         val: eachGroup.grp_id,
      //         text: eachGroup.grp_name
      //       }
      //     })
      //   } else {
      //     this.grpOpt = []
      //   }
      // })
      
    },
    setSelectedItem (title, condition, option_ch) {
      this.status = 'STATUS_PREVIEW_CLIENT'
      this.condition_title = title
      this.condition_data = condition
      this.option_ch = option_ch
    },
    goReleaseTable(title, condition, option_ch, update_status = true) {
      this.status = 'STATUS_RELEASE_TABLE'
      if (update_status) {
        this.condition_title = title
        this.condition_data = condition
        this.option_ch = option_ch
      }
    },
    returnUnitCondition () {
      this.status = 'STATUS_UNIT_CONDITION'
    },
    //初始化所有客戶標籤
    setCustTagOpt() {
      getAllCustTag(this.$store.state.userInfo.id).then(result => {
        if (result.body.result) {
          this.custTagOpt = result.body.result.cust_tag.map(item => {
            let tagName = item.tag_show_name ? item.tag_show_name : item.tag_name;
            this.allTagOpt.push({ text: tagName, val: item.tag_id });
            return {
              tag_name: tagName,
              text: tagName,
              val: item.tag_id,
              tag_agdef: item.tag_agdef
            }
          });
          this.custTagDef = result.body.result.cust_tag_def || {};
        } else {
          this.custTagOpt = [];
          this.allTagOpt = [];
          this.custTagDef = {};
        }
      });
    },
    //初始化所有商品類別
    setProdTypeOpt() {
      getAllProdType(this.$store.state.userInfo.id).then(result => {
        if (result.body.result) {
          result.body.result.forEach(item => {
            let category = item.prod_category.trim();
            if (category == "保障型") {
              this.prodType1_Opt.push({
                text: item.second_category,
                val: item.mapping_column
              });
            } else if (category == "理財型") {
              this.prodType2_Opt.push({
                text: item.second_category,
                val: item.mapping_column
              });
            }
          });
        } else {
          this.prodType1_Opt = [];
          this.prodType2_Opt = [];
        }
      });
    },
    //近期生日下拉選單初始化
    setRecentBirthdayOpt() {
      this.formSelect.recent_birthday = [];
      for (let i = 1; i <= 30; i++) {
        this.formSelect.recent_birthday.push({ name: i.toString(), option: i.toString(), field_description: "近期生日", field_name: "recent_birthday" });
      }
    }
  },
  mounted () {
    //  初始化
    this.initIndex()
  }
}
</script>